(function () {
  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!res.ok) return null;
    return res.json();
  }

  function setOptInUI(isChecked) {
    const box = document.getElementById("afterDarkUpsell");
    if (!box) return;
    box.classList.toggle("active", !!isChecked);
  }

  function findMainFormFromButton(button) {
    return button.closest('form[action*="/cart/add"]');
  }

  function getMainVariantId(form) {
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function getQuantity(form) {
    const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function openAndRefreshCartDrawer(cart) {
    // 1) Try Dawn-style cart drawer custom element
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      // Some themes will re-render automatically when opening; we also broadcast events.
      drawer.open();
    }

    // 2) Broadcast common events (different themes listen to different ones)
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:change", { detail: { cart }, bubbles: true }));

    // 3) If theme has a cart icon bubble that opens the drawer on click, try it
    const cartLink =
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('[aria-controls*="CartDrawer"]');

    // Only click it if we don't already have a working drawer.open()
    if ((!drawer || typeof drawer.open !== "function") && cartLink) {
      cartLink.click();
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const checkbox = document.getElementById("afterDarkClub");
    if (!checkbox) return;

    // Set initial UI state (important if page reloads / back button)
    setOptInUI(checkbox.checked);

    checkbox.addEventListener("change", () => {
      setOptInUI(checkbox.checked);
    });
  });

  // Intercept Add To Cart clicks (capture phase beats theme JS)
  document.addEventListener(
    "click",
    async (e) => {
      const button = e.target.closest('button[name="add"], button[type="submit"]');
      if (!button) return;

      const form = findMainFormFromButton(button);
      if (!form) return;

      const checkbox = document.getElementById("afterDarkClub");
      if (!checkbox || !checkbox.checked) return; // let theme handle normal ATC

      const afterDarkVariantId = parseInt(checkbox.dataset.afterDarkVariantId, 10);
      const afterDarkSellingPlanId = parseInt(checkbox.dataset.afterDarkSellingPlanId, 10);

      // If these are missing, do not hijack ATC
      if (!afterDarkVariantId || !afterDarkSellingPlanId) return;

      const mainVariantId = getMainVariantId(form);
      if (!mainVariantId) return;

      const mainQty = getQuantity(form);

      e.preventDefault();
      e.stopImmediatePropagation();

      try {
        await addItems([
          { id: mainVariantId, quantity: mainQty },
          { id: afterDarkVariantId, quantity: 1, selling_plan: afterDarkSellingPlanId }
        ]);

        const cart = await getCart();
        openAndRefreshCartDrawer(cart);
      } catch (err) {
        console.error("After Dark add failed:", err);
        // Fallback: let theme add main product at least
        form.submit();
      }
    },
    true
  );
})();
